import { arrayWithoutEmptyOrNull } from "./arrayWithoutEmptyOrNull";

export function stringifyArrayRemoveIds(array, isItemSet = null) {
    array = arrayWithoutEmptyOrNull(array, isItemSet);
    if (array === null) return null;

    array = array.map(({ id, ...rest }) => rest);
    return JSON.stringify(array);
}
